import { render, staticRenderFns } from "./Intransit.vue?vue&type=template&id=31b91bac&"
import script from "./Intransit.vue?vue&type=script&lang=js&"
export * from "./Intransit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports